import React, { useState, useEffect, useRef } from 'react';

const STYLES = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&display=swap');
@import url('https://api.fontshare.com/v2/css?f[]=clash-display@400,500,600,700&display=swap');
:root{--navy:#06112b;--navy2:#0d1f45;--navy3:#112359;--blue:#1c73ba;--blue2:#2b8de0;--blue3:#5aaef7;--gold:#f5a623;--gold2:#ffc94d;--muted:#94a3b8;--border:rgba(28,115,186,0.15);}
.fw-page{min-height:100vh;background:linear-gradient(145deg,var(--navy) 0%,var(--navy3) 60%,#1a3570 100%);font-family:'DM Sans',sans-serif;color:#fff;overflow-x:hidden;}
.fw-page::before{content:'';position:fixed;inset:0;background-image:linear-gradient(rgba(28,115,186,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(28,115,186,0.05) 1px,transparent 1px);background-size:52px 52px;pointer-events:none;z-index:0;}
.fw-nav{position:sticky;top:0;z-index:50;display:flex;align-items:center;justify-content:space-between;padding:0 5%;height:68px;background:rgba(6,17,43,0.9);backdrop-filter:blur(20px);border-bottom:1px solid var(--border);}
.fw-logo{font-family:'Clash Display',sans-serif;font-size:1.5rem;font-weight:700;color:#fff;text-decoration:none;}
.fw-logo span{color:var(--gold);}
.fw-back{background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:8px;padding:7px 14px;color:rgba(255,255,255,0.75);font-size:0.85rem;cursor:pointer;text-decoration:none;transition:background 0.2s;}
.fw-back:hover{background:rgba(255,255,255,0.12);color:#fff;}
.fw-hero{padding:72px 5% 48px;position:relative;z-index:1;max-width:1200px;margin:0 auto;display:grid;grid-template-columns:1fr 1fr;gap:56px;align-items:center;}
@media(max-width:860px){.fw-hero{grid-template-columns:1fr;gap:32px;}}
.fw-eyebrow{display:inline-flex;align-items:center;gap:8px;background:rgba(245,166,35,0.12);border:1px solid rgba(245,166,35,0.3);border-radius:99px;padding:5px 14px;font-size:0.72rem;font-weight:700;color:var(--gold);letter-spacing:2px;text-transform:uppercase;margin-bottom:20px;}
.fw-eyebrow-dot{width:6px;height:6px;border-radius:50%;background:var(--gold);animation:fwPulse 2s infinite;}
@keyframes fwPulse{0%,100%{box-shadow:0 0 0 0 rgba(245,166,35,0.4);}50%{box-shadow:0 0 0 5px rgba(245,166,35,0);}}
.fw-h1{font-family:'Clash Display',sans-serif;font-size:clamp(2rem,3.5vw + 0.5rem,3.2rem);font-weight:700;line-height:1.1;margin-bottom:16px;}
.fw-h1 em{font-style:normal;color:var(--blue3);}
.fw-sub{font-size:1rem;color:rgba(255,255,255,0.6);line-height:1.7;max-width:460px;margin-bottom:28px;}
/* Color selector */
.fw-colors{display:flex;gap:10px;flex-wrap:wrap;margin-bottom:20px;}
.fw-color-btn{width:44px;height:44px;border-radius:10px;border:2px solid transparent;cursor:pointer;transition:border-color 0.2s,transform 0.2s;position:relative;}
.fw-color-btn.active{border-color:#fff;transform:scale(1.1);}
.fw-color-btn.active::after{content:'✓';position:absolute;inset:0;display:flex;align-items:center;justify-content:center;color:#fff;font-size:14px;font-weight:700;}
/* Gallery */
.fw-gallery{border-radius:22px;overflow:hidden;background:rgba(13,31,69,0.6);border:1px solid rgba(28,115,186,0.2);position:relative;box-shadow:0 20px 60px rgba(0,0,0,0.4);}
.fw-gallery-hero{width:100%;aspect-ratio:16/9;object-fit:contain;padding:24px;display:block;transition:opacity 0.3s;}
.fw-carousel-nav{position:absolute;top:50%;transform:translateY(-50%);width:34px;height:34px;border-radius:50%;background:rgba(6,17,43,0.8);border:1px solid var(--border);color:rgba(255,255,255,0.8);font-size:18px;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:5;transition:background 0.2s;}
.fw-carousel-nav:hover{background:rgba(28,115,186,0.3);}
.fw-carousel-nav.prev{left:10px;}
.fw-carousel-nav.next{right:10px;}
.fw-thumb-row{display:flex;gap:8px;padding:10px 14px 14px;overflow-x:auto;}
.fw-thumb{width:60px;height:40px;border-radius:8px;object-fit:contain;border:2px solid transparent;cursor:pointer;transition:border-color 0.2s;flex-shrink:0;background:rgba(255,255,255,0.04);padding:2px;}
.fw-thumb.active{border-color:var(--blue3);}
/* Body */
.fw-body{padding:40px 5% 64px;position:relative;z-index:1;max-width:1200px;margin:0 auto;}
.fw-grid{display:grid;grid-template-columns:1fr 380px;gap:40px;align-items:start;}
@media(max-width:860px){.fw-grid{grid-template-columns:1fr;}}
/* Order */
.fw-order{background:rgba(255,255,255,0.03);border:1px solid rgba(28,115,186,0.2);border-radius:20px;padding:28px;position:relative;overflow:hidden;backdrop-filter:blur(16px);}
.fw-order::before{content:'';position:absolute;top:-30%;right:-30%;width:60%;height:60%;background:radial-gradient(circle,rgba(245,166,35,0.06) 0%,transparent 70%);pointer-events:none;}
.fw-section-label{display:block;font-size:0.72rem;font-weight:700;letter-spacing:2.5px;text-transform:uppercase;color:var(--blue3);margin-bottom:12px;}
.fw-section-heading{font-family:'Clash Display',sans-serif;font-size:clamp(1.4rem,2.5vw,2rem);font-weight:700;color:#fff;line-height:1.15;margin-bottom:8px;}
.fw-section-heading em{font-style:normal;color:var(--gold);}
.fw-price{font-family:'Clash Display',sans-serif;font-size:2.2rem;font-weight:700;color:var(--gold);line-height:1;margin-bottom:4px;}
.fw-price-sub{font-size:0.8rem;color:var(--muted);margin-bottom:20px;}
.fw-field-label{font-size:0.72rem;font-weight:700;color:var(--muted);text-transform:uppercase;letter-spacing:1.5px;display:block;margin-bottom:8px;}
.fw-stepper{display:flex;align-items:center;gap:0;background:rgba(255,255,255,0.05);border:1px solid var(--border);border-radius:10px;overflow:hidden;margin-bottom:20px;width:fit-content;}
.fw-stp-btn{width:42px;height:42px;background:transparent;border:none;color:var(--blue3);font-size:1.2rem;cursor:pointer;transition:background 0.2s;}
.fw-stp-btn:hover{background:rgba(28,115,186,0.15);}
.fw-stp-val{width:52px;text-align:center;background:transparent;border:none;border-left:1px solid var(--border);border-right:1px solid var(--border);color:#fff;font-size:0.95rem;font-weight:600;height:42px;font-family:'DM Sans',sans-serif;}
.fw-btn-gold{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:13px 24px;background:linear-gradient(135deg,var(--gold),var(--gold2));color:var(--navy);border:none;border-radius:10px;font-family:'DM Sans',sans-serif;font-size:0.95rem;font-weight:700;cursor:pointer;transition:transform 0.2s,box-shadow 0.2s;box-shadow:0 6px 24px rgba(245,166,35,0.3);margin-bottom:10px;}
.fw-btn-gold:hover{transform:translateY(-2px);box-shadow:0 10px 32px rgba(245,166,35,0.4);}
.fw-btn-sec{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:12px 24px;background:rgba(255,255,255,0.06);color:rgba(255,255,255,0.8);border:1px solid rgba(255,255,255,0.14);border-radius:10px;font-family:'DM Sans',sans-serif;font-size:0.9rem;font-weight:600;cursor:pointer;transition:background 0.2s,transform 0.2s;}
.fw-btn-sec:hover{background:rgba(255,255,255,0.12);transform:translateY(-2px);}
/* Description */
.fw-desc-section{margin-top:32px;}
.fw-desc-text{font-size:0.88rem;color:rgba(255,255,255,0.65);line-height:1.75;margin-bottom:20px;}
.fw-feats-list{display:flex;flex-direction:column;gap:8px;}
.fw-feat-item{display:flex;gap:10px;align-items:flex-start;font-size:0.85rem;color:rgba(255,255,255,0.65);line-height:1.55;}
.fw-feat-dot{color:var(--gold);font-size:13px;margin-top:1px;flex-shrink:0;}
/* Features section */
.fw-features{padding:64px 5%;background:rgba(6,17,43,0.5);border-top:1px solid var(--border);border-bottom:1px solid var(--border);position:relative;z-index:1;}
.fw-features-inner{max-width:1100px;margin:0 auto;}
.fw-features-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:16px;margin-top:32px;}
.fw-feat-card{background:rgba(255,255,255,0.03);border:1px solid var(--border);border-radius:16px;padding:20px;transition:border-color 0.3s,transform 0.3s;position:relative;overflow:hidden;}
.fw-feat-card::before{content:'';position:absolute;top:0;left:0;right:0;height:2px;background:linear-gradient(90deg,var(--blue),var(--blue3));transform:scaleX(0);transform-origin:left;transition:transform 0.3s;}
.fw-feat-card:hover{border-color:rgba(28,115,186,0.35);transform:translateY(-3px);}
.fw-feat-card:hover::before{transform:scaleX(1);}
.fw-feat-icon{font-size:24px;margin-bottom:8px;display:block;}
.fw-feat-title{font-family:'Clash Display',sans-serif;font-size:0.9rem;font-weight:700;color:#fff;margin-bottom:4px;}
.fw-feat-desc{font-size:0.78rem;color:rgba(255,255,255,0.5);line-height:1.55;}
/* Modal */
.fw-modal-overlay{position:fixed;inset:0;z-index:200;background:rgba(6,17,43,0.88);backdrop-filter:blur(12px);display:flex;align-items:center;justify-content:center;padding:24px;}
.fw-modal{background:linear-gradient(145deg,var(--navy2),var(--navy3));border:1px solid rgba(28,115,186,0.3);border-radius:24px;padding:36px;max-width:480px;width:100%;box-shadow:0 24px 80px rgba(0,0,0,0.6);position:relative;}
.fw-modal-close{position:absolute;top:16px;right:16px;width:32px;height:32px;border-radius:50%;background:rgba(255,255,255,0.08);border:none;color:rgba(255,255,255,0.6);font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:background 0.2s;}
.fw-modal-close:hover{background:rgba(255,255,255,0.15);color:#fff;}
.fw-demo-scene{display:flex;align-items:center;justify-content:center;gap:28px;padding:20px 0;}
.fw-demo-wallet{width:100px;height:65px;border-radius:8px;object-fit:contain;border:2px solid var(--border);}
.fw-demo-phone{width:130px;height:250px;background:#0a0a0a;border-radius:20px;border:2px solid #333;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 16px 40px rgba(0,0,0,0.6);}
.fw-demo-bar{height:26px;background:#111;display:flex;align-items:center;justify-content:center;}
.fw-demo-notch{width:44px;height:7px;background:#222;border-radius:99px;}
.fw-demo-screen{flex:1;background:#0d1f45;display:flex;flex-direction:column;align-items:center;justify-content:center;padding:8px;gap:6px;}
.fw-demo-msg{font-size:9px;color:var(--blue3);text-align:center;font-weight:600;animation:fwFadePulse 1s infinite;}
@keyframes fwFadePulse{0%,100%{opacity:1}50%{opacity:0.4}}
.fw-demo-profile{display:flex;flex-direction:column;align-items:center;gap:4px;width:100%;}
.fw-demo-avatar{width:36px;height:36px;border-radius:50%;background:linear-gradient(135deg,var(--blue),var(--blue3));display:flex;align-items:center;justify-content:center;font-size:14px;color:#fff;font-weight:700;}
.fw-demo-name{font-size:9px;color:#fff;font-weight:700;}
.fw-demo-role{font-size:7px;color:var(--muted);}
.fw-demo-chips{display:flex;gap:3px;flex-wrap:wrap;justify-content:center;}
.fw-demo-chip{font-size:6px;padding:2px 5px;border-radius:99px;background:rgba(28,115,186,0.2);color:var(--blue3);border:1px solid rgba(28,115,186,0.3);}
.fw-toast{position:fixed;bottom:28px;left:50%;transform:translateX(-50%);background:rgba(13,31,69,0.97);color:#fff;border:1px solid var(--border);border-radius:10px;padding:12px 22px;font-size:0.85rem;font-weight:600;z-index:300;box-shadow:0 8px 32px rgba(0,0,0,0.4);animation:fwToastUp 0.3s ease;}
@keyframes fwToastUp{from{transform:translateX(-50%) translateY(10px);opacity:0;}}
`;

const COLORS = [
  { key:'red',   hex:'#c0392b', imgs:['/images/flapcardholderred_front.png',  '/images/flapcardholderred_back.png']   },
  { key:'black', hex:'#2c2c2c', imgs:['/images/flapcardholderblack_front.png','/images/flapcardholderblack_back.png'] },
  { key:'green', hex:'#1e4d2b', imgs:['/images/flapcardholdergreen_front.png','/images/flapcardholdergreen_back.png'] },
];
const COVERS = [
  '/images/flapcardholder1.png','/images/flapcardholder2.png',
  '/images/flapcardholder3.png','/images/flapcardholder4.png','/images/flapcardholder5.png',
];
const FEATURES = [
  { icon:'📲', title:'NFC Tap Share',      desc:'Single tap shares your full digital profile — no app, no friction.' },
  { icon:'📷', title:'QR Backup',          desc:'Every holder includes a QR code for devices without NFC.' },
  { icon:'🔔', title:'Lost & Found Alerts',desc:'If lost, the finder sees your contact message and can notify you instantly.' },
  { icon:'💳', title:'Card + Cash Slots',  desc:'Fits 4–6 cards and has a secure cash pocket.' },
  { icon:'🌿', title:'Eco-Friendly',       desc:'Premium materials with minimal environmental impact.' },
  { icon:'🔗', title:'Always Updated',     desc:'Change your linked profile anytime — no reprinting needed.' },
];
const fmt = n => `Rs. ${n.toLocaleString('en-IN')}`;

export default function Flapwallet() {
  const [colorKey, setColorKey] = useState('black');
  const [imgIdx,   setImgIdx]   = useState(0);
  const [qty,      setQty]      = useState(1);
  const [toast,    setToast]    = useState('');
  const [demo,     setDemo]     = useState(false);
  const [demoStep, setDemoStep] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [form,     setForm]     = useState({ name:'', address:'', phone:'', email:'', qty:1 });
  const timerRef = useRef(null);

  const color   = COLORS.find(c => c.key === colorKey);
  const allImgs = [...COVERS, ...color.imgs];

  useEffect(() => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => setImgIdx(i => (i+1) % COVERS.length), 4500);
    return () => clearInterval(timerRef.current);
  }, []);

  const showToast = msg => { setToast(msg); setTimeout(()=>setToast(''), 2800); };

  const handleOrder = () => {
    setShowForm(true);
  };

  const handleFormSubmit = () => {
    showToast('Opening WhatsApp…');
    const msg = `Order Details:\nProduct: Flap Card Holder\nColor: ${colorKey}\nQty: ${form.qty}\nTotal: ${fmt(form.qty*2999)}\nName: ${form.name}\nAddress: ${form.address}\nPhone: ${form.phone}\nEmail: ${form.email}`;
    setTimeout(() => { window.open(`https://wa.me/9779802365432?text=${encodeURIComponent(msg)}`, '_blank'); setShowForm(false); }, 900);
  };

  const handleDemo = () => {
    setDemo(true); setDemoStep(1);
    setTimeout(()=>setDemoStep(2), 800);
    setTimeout(()=>setDemoStep(3), 1800);
    setTimeout(()=>setDemoStep(4), 2600);
  };

  const curImg = allImgs[imgIdx] || COVERS[0];

  return (
    <div className="fw-page">
      <style>{STYLES}</style>
      <nav className="fw-nav">
        <a href="/" className="fw-logo">flap<span>.</span></a>
        <a href="/" className="fw-back">← Back to home</a>
      </nav>

      {/* Hero */}
      <section className="fw-hero">
        <div>
          <div className="fw-eyebrow"><span className="fw-eyebrow-dot"/>NFC Wallet · Rs. 2,999</div>
          <h1 className="fw-h1">Flap <em>Card Holder</em></h1>
          <p className="fw-sub">
            The smartest wallet you'll ever carry. NFC chip built-in for instant contact sharing, QR code backup,
            and a lost & found alert system — all in a slim premium holder.
          </p>
          {/* Color picker */}
          <div style={{ fontSize:'0.72rem', fontWeight:700, color:'var(--muted)', textTransform:'uppercase', letterSpacing:1.5, marginBottom:10 }}>
            Color — {colorKey.charAt(0).toUpperCase()+colorKey.slice(1)}
          </div>
          <div className="fw-colors">
            {COLORS.map(c => (
              <div key={c.key} className={`fw-color-btn ${colorKey===c.key?'active':''}`}
                style={{ background: c.hex }}
                onClick={() => { setColorKey(c.key); setImgIdx(0); }}
                title={c.key}/>
            ))}
          </div>
          <div style={{ display:'flex', gap:12, flexWrap:'wrap', marginTop:20 }}>
            <button className="fw-btn-gold" style={{ width:'auto', padding:'11px 28px' }} onClick={handleOrder}>
              Order Now — Rs. 2,999
            </button>
            <button className="fw-btn-sec" style={{ width:'auto', padding:'11px 28px' }} onClick={handleDemo}>
              ▶ See Demo
            </button>
          </div>
        </div>

        {/* Gallery */}
        <div>
          <div className="fw-gallery">
            <img src={curImg} alt="Flap Card Holder" className="fw-gallery-hero"/>
            <button className="fw-carousel-nav prev" onClick={()=>setImgIdx(i=>(i-1+allImgs.length)%allImgs.length)}>‹</button>
            <button className="fw-carousel-nav next" onClick={()=>setImgIdx(i=>(i+1)%allImgs.length)}>›</button>
          </div>
          <div className="fw-thumb-row">
            {allImgs.map((img,i) => (
              <img key={i} src={img} alt="" className={`fw-thumb ${imgIdx===i?'active':''}`} onClick={()=>setImgIdx(i)}/>
            ))}
          </div>
        </div>
      </section>

      {/* Body */}
      <div className="fw-body">
        <div className="fw-grid">
          {/* Left: description + features list */}
          <div className="fw-desc-section">
            <span className="fw-section-label">About</span>
            <h2 className="fw-section-heading">The flagship <em>Flap Holder</em></h2>
            <p className="fw-desc-text">
              Designed for professionals and tech enthusiasts, the Flap Card Holder combines secure storage for cards
              and cash with smart contact sharing and a lost & found notification system. Eco-friendly, durable, and
              stylish — the ultimate networking accessory for the digital age.
            </p>
            <div className="fw-feats-list">
              {['Built-in NFC for instant contact sharing with a tap','QR code for quick profile access on any device','Lost & Found alerts — notify owners instantly if misplaced','Compact design with slots for cards, cash, and IDs','Eco-friendly alternative to traditional wallets'].map(f=>(
                <div key={f} className="fw-feat-item">
                  <span className="fw-feat-dot">✓</span>{f}
                </div>
              ))}
            </div>
          </div>

          {/* Right: order */}
          <div className="fw-order">
            <span className="fw-section-label">Order</span>
            <div className="fw-price">Rs. 2,999</div>
            <div className="fw-price-sub">Flap Card Holder · NFC + QR · free delivery in KTM</div>

            <label className="fw-field-label">Color</label>
            <div className="fw-colors" style={{ marginBottom:20 }}>
              {COLORS.map(c=>(
                <div key={c.key} className={`fw-color-btn ${colorKey===c.key?'active':''}`}
                  style={{ background:c.hex, width:36, height:36 }}
                  onClick={()=>setColorKey(c.key)}
                  title={c.key}/>
              ))}
            </div>

            <label className="fw-field-label">Quantity</label>
            <div className="fw-stepper">
              <button className="fw-stp-btn" onClick={()=>setQty(q=>Math.max(1,q-1))}>−</button>
              <input className="fw-stp-val" type="number" value={qty} min="1" onChange={e=>setQty(Math.max(1,+e.target.value))}/>
              <button className="fw-stp-btn" onClick={()=>setQty(q=>q+1)}>+</button>
            </div>
            <div style={{ fontSize:'0.8rem', color:'var(--muted)', marginBottom:20 }}>
              Total: <strong style={{color:'var(--gold)'}}>{fmt(qty*2999)}</strong>
            </div>

            <button className="fw-btn-gold" onClick={handleOrder}>📱 Order via WhatsApp</button>
            <button className="fw-btn-sec" onClick={handleDemo}>▶ View Demo</button>

            <div style={{ marginTop:22, paddingTop:18, borderTop:'1px solid rgba(255,255,255,0.07)' }}>
              <div style={{ fontSize:'0.72rem', color:'var(--muted)', textTransform:'uppercase', letterSpacing:1.5, marginBottom:10 }}>Includes</div>
              {['NFC pre-programmed & tested','Flap profile activation','Lost & Found system active','1-year warranty'].map(i=>(
                <div key={i} style={{ display:'flex', gap:8, alignItems:'center', marginBottom:7 }}>
                  <span style={{ color:'var(--gold)', fontSize:12 }}>✓</span>
                  <span style={{ fontSize:'0.82rem', color:'rgba(255,255,255,0.6)' }}>{i}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Features */}
      <section className="fw-features">
        <div className="fw-features-inner">
          <span className="fw-section-label">Features</span>
          <h2 style={{ fontFamily:"'Clash Display',sans-serif", fontSize:'clamp(1.5rem,2.5vw,2.2rem)', fontWeight:700, color:'#fff' }}>
            Your wallet, <span style={{color:'var(--gold)'}}>upgraded</span>
          </h2>
          <div className="fw-features-grid">
            {FEATURES.map(f=>(
              <div className="fw-feat-card" key={f.title}>
                <span className="fw-feat-icon">{f.icon}</span>
                <div className="fw-feat-title">{f.title}</div>
                <div className="fw-feat-desc">{f.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Demo modal */}
      {demo && (
        <div className="fw-modal-overlay" onClick={e=>{ if(e.target===e.currentTarget){setDemo(false);setDemoStep(0);}}}>
          <div className="fw-modal">
            <button className="fw-modal-close" onClick={()=>{setDemo(false);setDemoStep(0);}}>✕</button>
            <h3 style={{ fontFamily:"'Clash Display',sans-serif", fontSize:'1.25rem', fontWeight:700, color:'#fff', marginBottom:6 }}>Tap to Connect</h3>
            <p style={{ fontSize:'0.82rem', color:'var(--muted)', marginBottom:20 }}>Hold your Card Holder near any NFC phone — your profile appears instantly.</p>
            <div className="fw-demo-scene">
              <img src={color.imgs[0]} alt="Wallet" className="fw-demo-wallet"
                style={{ transform:demoStep>=2?'translateX(12px) scale(0.95)':'none', transition:'transform 0.5s' }}/>
              <div style={{ fontSize:20, color:'var(--blue3)', animation:demoStep>=2?'fwFadePulse 0.8s 2':'none' }}>→</div>
              <div className="fw-demo-phone">
                <div className="fw-demo-bar"><div className="fw-demo-notch"/></div>
                <div className="fw-demo-screen">
                  {demoStep===1 && <div className="fw-demo-msg">📡 Scanning…</div>}
                  {demoStep===2 && <div className="fw-demo-msg">⚡ NFC detected!</div>}
                  {demoStep===3 && <div className="fw-demo-msg">✅ Profile loading…</div>}
                  {demoStep>=4 && (
                    <div className="fw-demo-profile">
                      <div className="fw-demo-avatar">F</div>
                      <div className="fw-demo-name">Your Name</div>
                      <div className="fw-demo-role">flap.com.np/you</div>
                      <div className="fw-demo-chips">
                        {['LinkedIn','Email','Phone','Website'].map(l=><span key={l} className="fw-demo-chip">{l}</span>)}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {demoStep>=4
              ? <button className="fw-btn-gold" style={{ marginTop:16 }} onClick={()=>{ setDemo(false); setDemoStep(0); handleOrder(); }}>Order Now — Rs. 2,999</button>
              : <button className="fw-btn-sec" style={{ marginTop:16 }} onClick={handleDemo}>▶ Restart</button>
            }
          </div>
        </div>
      )}

      {/* Order form modal */}
      {showForm && (
        <div className="fw-modal-overlay" onClick={e=>{ if(e.target===e.currentTarget) setShowForm(false); }}>
          <div className="fw-modal" style={{ maxWidth:440 }}>
            <button className="fw-modal-close" onClick={()=>setShowForm(false)}>✕</button>
            <h3 style={{ fontFamily:"'Clash Display',sans-serif", fontSize:'1.2rem', fontWeight:700, color:'#fff', marginBottom:20 }}>
              Order Details
            </h3>
            {[['name','Name','text'],['address','Delivery Address','text'],['phone','Phone Number','tel'],['email','Email','email']].map(([field,label,type])=>(
              <div key={field} style={{ marginBottom:14 }}>
                <label style={{ fontSize:'0.72rem', fontWeight:700, color:'var(--muted)', textTransform:'uppercase', letterSpacing:1.5, display:'block', marginBottom:6 }}>{label}</label>
                <input type={type} value={form[field]} onChange={e=>setForm(f=>({...f,[field]:e.target.value}))}
                  style={{ width:'100%', padding:'11px 14px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(28,115,186,0.2)', borderRadius:10, color:'#fff', fontFamily:'DM Sans,sans-serif', fontSize:'0.9rem', outline:'none', boxSizing:'border-box' }}/>
              </div>
            ))}
            <div style={{ marginBottom:14 }}>
              <label style={{ fontSize:'0.72rem', fontWeight:700, color:'var(--muted)', textTransform:'uppercase', letterSpacing:1.5, display:'block', marginBottom:6 }}>Quantity</label>
              <input type="number" value={form.qty} min="1" onChange={e=>setForm(f=>({...f,qty:Math.max(1,+e.target.value)}))}
                style={{ width:100, padding:'11px 14px', background:'rgba(255,255,255,0.05)', border:'1px solid rgba(28,115,186,0.2)', borderRadius:10, color:'#fff', fontFamily:'DM Sans,sans-serif', fontSize:'0.9rem', outline:'none' }}/>
              <span style={{ marginLeft:10, color:'var(--gold)', fontSize:'0.85rem', fontWeight:600 }}>Total: {fmt(form.qty*2999)}</span>
            </div>
            <div style={{ display:'flex', gap:10, marginTop:20 }}>
              <button className="fw-btn-sec" style={{ flex:1 }} onClick={()=>setShowForm(false)}>Cancel</button>
              <button className="fw-btn-gold" style={{ flex:1 }} onClick={handleFormSubmit}>Submit Order</button>
            </div>
          </div>
        </div>
      )}

      {toast && <div className="fw-toast">{toast}</div>}
    </div>
  );
}